import { FlagDropdown } from '@dealstack/frontend/shared/components/forms/PhoneNumberInput/FlagDropdown';
import { useState } from 'react';
import flags from 'react-phone-number-input/flags';
import { Country } from 'react-phone-number-input/mobile';
import type { Option } from './CountrySelect.types';
import { DownChevron } from './DownChevron';

interface Props {
	flag?: string;
	value: Country;
	options: Option[];
	readOnly: boolean;
	onChange: (value: string) => void;
}

export const CountrySelect = ({ readOnly, value, onChange, options }: Props) => {
	const [showDropdown, setShouldShowDropdown] = useState(false);

	if (readOnly) {
		return <></>;
	}

	return (
		<div
			onClick={() => {
				setShouldShowDropdown(!showDropdown);
			}}
			className="flex items-center justify-center bg-gray-50 hover:bg-gray-100 cursor-pointer relative h-[100%] mr-1"
		>
			<div className="flex gap-2 justify-center px-4 ">
				<div className="w-[25px] flex justify-center align-middle h-[25px]">
					{flags?.[value || 'GB']?.({ title: 'title' })}
				</div>
				<div className="flex justify-center self-center ">
					<DownChevron />
				</div>
			</div>

			{showDropdown && (
				<FlagDropdown
					options={options}
					setSelectedCountry={(country) => {
						onChange(country.value);
					}}
				/>
			)}
		</div>
	);
};
